import React, { useState } from 'react'
import { toast, Notification, Checkbox } from 'components/ui'
import { ConfirmDialog } from 'components/shared'
import { useSelector, useDispatch } from 'react-redux'
import { toggleDeleteConfirmation } from '../store/stateSlice'
import { deleteSocialNetwork, getSocialNetworkList } from '../store/dataSlice'
import { useTranslation } from 'react-i18next';

const SocialNetworkDeleteConfirmation = () => {
	const dispatch = useDispatch()
	const dialogOpen = useSelector((state) => state.socialnetworksList.state.deleteConfirmation)
	const selectedProduct = useSelector((state) => state.socialnetworksList.state.selectedProduct)
	const tableData = useSelector((state) => state.socialnetworksList.data.tableData)
	const selectedLanguage = useSelector((state) => state.selectLang.data.selectedLanguage);
	const [webMultiLang, setWebMultiLang] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const handleCheckboxChange = (e) => {
		setWebMultiLang(e);
	};
	const { t } = useTranslation();
	const onDialogClose = () => {
		dispatch(toggleDeleteConfirmation(false))
		setWebMultiLang(false);
	}

	const onDelete = async () => {
		dispatch(toggleDeleteConfirmation(false))

		try {
			const success = await deleteSocialNetwork({ Id: selectedProduct, webLangId: selectedLanguage, WebMultiLang: webMultiLang })
			if (success) {
				setIsLoading(false);
				const updatedTableData = { ...tableData, webLangId: selectedLanguage };
				dispatch(getSocialNetworkList(updatedTableData));
				dispatch(toggleDeleteConfirmation(false))
				toast.push(
					<Notification className="mr-2 mb-2" title={t('toast.deleteSuccess')} type="success" duration={1000} />
				)
			}
		} catch (error) {
			toast.push(
				<Notification title={t('toast.deleteFailed')} type="danger" duration={2000}>
				</Notification>
				, {
					placement: 'top-center'
				}
			)

		} finally {
			setWebMultiLang(false);
		}
	}

	return (
		<ConfirmDialog
			isOpen={dialogOpen}
			onClose={onDialogClose}
			loading={isLoading}
			onRequestClose={onDialogClose}
			type="danger"
			title={t('translation.icondelete')}
			onCancel={onDialogClose}
			onConfirm={onDelete}
			confirmButtonColor="red-600"
		>
			<p>
				{t('delete.notifydelete')}
			</p>
			<Checkbox
				className="mt-2.5"
				value={webMultiLang}
				onChange={(e) => handleCheckboxChange(e)}
			>
				{t('delete.otherLanguages')}
			</Checkbox>
		</ConfirmDialog>
	)
}

export default SocialNetworkDeleteConfirmation